import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do on the trip page. UX only: the server stays the authority. */
export function useTripPermissions() {
  const { state } = useCurrentUser();
  const has = (permission: string) => state.status === 'authenticated' && state.user.permissions.includes(permission);

  return {
    canDispatch: has('trip.dispatch'),
    canCommunicate: has('trip.communicate'),
    canViewHistory: has('audit.view'),
    canViewFleet: has('fleet.view'),
    canTopUp: has('advance.issue'),
    canViewCash: has('driver_ledger.view'),
    canRecordCash: has('driver_ledger.record'),
  };
}
